var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page',{attrs:{"title":_vm.title}},[(_vm.$isAdmin)?_c('com-admin'):_vm._e(),(_vm.$isOrganisation)?_c('com-organisation'):_vm._e(),(_vm.$isClinic)?_c('com-clinic'):_vm._e(),(_vm.$isData)?_c('com-data'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }